module.exports = __webpack_public_path__ + "static/media/logo.40a1d796.png";